const _403_dp = (externalBaseUrl: string) => ({
	structure: {
		type: 'Page',
		styleId: '_403_dp_style',
		id: '_403_dp',
		components: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zs',
				dataQuery: '#dataItem-ivs730zs1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs730zt',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j18',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zu',
				dataQuery: '#dataItem-ivs730zu1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs730zv',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j13',
			},
			{
				type: 'Component',
				styleId: 'style-ivs76437',
				id: 'comp-ivs730zv1',
				dataQuery: '#dataItem-ivs730zv2',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzkkc0j7',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j8',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs73100',
				dataQuery: '#dataItem-ivs731001',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs73102',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j3',
			},
		],
		mobileComponents: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zs',
				dataQuery: '#dataItem-ivs730zs1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzkkc0j17',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j18',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs730zu',
				dataQuery: '#dataItem-ivs730zu1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzkkc0j12',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j13',
			},
			{
				type: 'Component',
				styleId: 'style-ivs76437',
				id: 'comp-ivs730zv1',
				dataQuery: '#dataItem-ivs730zv2',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'mobile_propItem-lzzkkc0j7',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j8',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs73100',
				dataQuery: '#dataItem-ivs731001',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs73102',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_403_dp',
				layoutQuery: '#layout-lzzkkc0j3',
			},
		],
		dataQuery: '#_403_dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: {
			x: 0,
			y: 0,
			height: 0,
			width: 0,
		},
		componentType: 'mobile.core.components.Page',
		layoutQuery: '#layout-lzzkkc0i',
	},
	data: {
		document_data: {
			_403_dp: {
				type: 'Page',
				id: '_403_dp',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				title: '403',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: '403',
				hidePage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: true,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#customBgImg3vn',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg3vn: {
				type: 'BackgroundMedia',
				id: 'customBgImg3vn',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			'dataItem-ivs730zs1': {
				type: 'StyledText',
				id: 'dataItem-ivs730zs1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<h4 class="font_4" style="font-size:66px"><span style="color:#EF7E6B"><span style="font-size:66px"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif">Hold Up There...</span></span></span></h4>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs730zu1': {
				type: 'StyledText',
				id: 'dataItem-ivs730zu1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<p class="font_7" style="font-size:22px; line-height:1.7em"><span style="color:#184A56"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif"><span style="font-size:22px">Looks like you don&rsquo;t have permission to view this page.</span></span></span></p>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs730zv2': {
				type: 'LinkableButton',
				id: 'dataItem-ivs730zv2',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				label: 'Go Back ',
				link: '#dataItem-iwis06js',
			},
			'dataItem-ivs731001': {
				type: 'Image',
				id: 'dataItem-ivs731001',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: '403.png',
				uri: '035244_9795292eb93245db90aa31852ea0afbf~mv2.png',
				description: '',
				width: 400,
				height: 282,
				alt: '',
				crop: {
					x: 27,
					y: 21,
					width: 346,
					height: 239,
				},
			},
			'dataItem-iwis06js': {
				type: 'ExternalLink',
				id: 'dataItem-iwis06js',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				url: externalBaseUrl,
				target: '_self',
			},
		},
		design_data: {},
		behaviors_data: {},
		connections_data: {},
		theme_data: {
			'style-ivs76437': {
				type: 'TopLevelStyle',
				id: 'style-ivs76437',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-bgh': '1',
						'alpha-brd': '1',
						'alpha-brdh': '0',
						'alpha-txt': '1',
						'alpha-txth': '1',
						bg: '#3EB8EA',
						bgh: '#EF7E6B',
						'boxShadowToggleOn-shd': 'false',
						brd: '#EF7E6B',
						brdh: '#3D9BE9',
						brw: '2',
						fnt: 'normal normal normal 22px/1.4em helvetica-w01-light',
						rd: '40px',
						shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
						txt: '#EF7E6B',
						txth: '#FFFFF1',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brdh': 'value',
						bg: 'value',
						bgh: 'value',
						brd: 'value',
						brdh: 'value',
						brw: 'value',
						fnt: 'value',
						rd: 'value',
						shd: 'value',
						txt: 'value',
						txth: 'value',
					},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.SiteButton',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
			},
		},
		component_properties: {
			'mobile_propItem-ivs730zt': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
			},
			'mobile_propItem-ivs730zv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
			},
			'propItem-ivs730zt': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-ivs730zv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-ivs730zw': {
				type: 'ButtonProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				align: 'center',
				margin: 0,
			},
			'propItem-ivs73102': {
				type: 'WPhotoProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				displayMode: 'fill',
				onClickBehavior: 'goToLink',
				effectName: 'none',
			},
			'propItem-lzzkkc0j7': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				id: 'propItem-lzzkkc0j7',
			},
			'mobile_propItem-lzzkkc0j7': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				fontScale: 0.863837598531476,
				id: 'mobile_propItem-lzzkkc0j7',
			},
			'propItem-lzzkkc0j12': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				fontScale: 0.6948499742213815,
				id: 'propItem-lzzkkc0j12',
			},
			'propItem-lzzkkc0j17': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
				fontScale: 0.8084127123905273,
				id: 'propItem-lzzkkc0j17',
			},
		},
		variants_data: {},
		layout_data: {
			'layout-lzzkkc0i': {
				id: 'layout-lzzkkc0i',
				type: 'RefArray',
				values: ['#layout-lzzkkc0j', '#layout-lzzkkc0j2'],
			},
			'layout-lzzkkc0j': {
				id: 'layout-lzzkkc0j',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j1': {
				id: 'layout-lzzkkc0j1',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j2': {
				id: 'layout-lzzkkc0j2',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkkc0j1',
				from: '#_403_dp',
			},
			'layout-lzzkkc0j3': {
				id: 'layout-lzzkkc0j3',
				type: 'RefArray',
				values: ['#layout-lzzkkc0j4', '#layout-lzzkkc0j6'],
			},
			'layout-lzzkkc0j4': {
				id: 'layout-lzzkkc0j4',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 339,
					},
					height: {
						type: 'px',
						value: 235,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 174,
						y: 100,
						width: 339,
						height: 235,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j5': {
				id: 'layout-lzzkkc0j5',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 272,
					},
					height: {
						type: 'px',
						value: 196,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 24,
						y: -23,
						width: 272,
						height: 196,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j6': {
				id: 'layout-lzzkkc0j6',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkkc0j5',
				from: '#comp-ivs73100',
			},
			'layout-lzzkkc0j8': {
				id: 'layout-lzzkkc0j8',
				type: 'RefArray',
				values: ['#layout-lzzkkc0j9', '#layout-lzzkkc0j11'],
			},
			'layout-lzzkkc0j9': {
				id: 'layout-lzzkkc0j9',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 198,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 599,
						width: 198,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j10': {
				id: 'layout-lzzkkc0j10',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 204,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 53,
						y: 372,
						width: 204,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j11': {
				id: 'layout-lzzkkc0j11',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkkc0j10',
				from: '#comp-ivs730zv1',
			},
			'layout-lzzkkc0j13': {
				id: 'layout-lzzkkc0j13',
				type: 'RefArray',
				values: ['#layout-lzzkkc0j14', '#layout-lzzkkc0j16'],
			},
			'layout-lzzkkc0j14': {
				id: 'layout-lzzkkc0j14',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 381,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 207,
						y: 482,
						width: 381,
						height: 76,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j15': {
				id: 'layout-lzzkkc0j15',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 277,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 21,
						y: 265,
						width: 277,
						height: 78,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j16': {
				id: 'layout-lzzkkc0j16',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkkc0j15',
				from: '#comp-ivs730zu',
			},
			'layout-lzzkkc0j18': {
				id: 'layout-lzzkkc0j18',
				type: 'RefArray',
				values: ['#layout-lzzkkc0j19', '#layout-lzzkkc0j21'],
			},
			'layout-lzzkkc0j19': {
				id: 'layout-lzzkkc0j19',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 701,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 379,
						width: 701,
						height: 81,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j20': {
				id: 'layout-lzzkkc0j20',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 320,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 0,
						y: 208,
						width: 320,
						height: 39,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkkc0j21': {
				id: 'layout-lzzkkc0j21',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkkc0j20',
				from: '#comp-ivs730zs',
			},
		},
		transformations_data: {},
	},
	title: '403',
	pageUriSEO: '403',
})

export default _403_dp
